import { useSelector } from 'react-redux';

/**
 * Hook para verificar restricciones de suscripción basadas en días vencidos
 * 
 * Reglas:
 * - 0-4 días vencido: Acceso completo con advertencias
 * - 5-9 días vencido: AFIP bloqueado, ventas no fiscales OK
 * - 10+ días vencido: TODO bloqueado
 */
export const useSubscriptionRestrictions = () => {
    const { tenant } = useSelector(state => state.tenant || {});

    const getDaysOverdue = () => {
        if (!tenant) return 0;

        const { currentPeriodEnd, subscriptionExpiresAt, subscriptionExpiry } = tenant;

        const expiry = currentPeriodEnd || subscriptionExpiresAt || subscriptionExpiry;
        if (!expiry) return 0;

        const now = new Date();
        const expiryDate = new Date(expiry);
        const diffMs = now.getTime() - expiryDate.getTime();
        const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

        return diffDays > 0 ? diffDays : 0;
    };

    const daysOverdue = getDaysOverdue();

    return {
        daysOverdue,
        canUseAFIP: daysOverdue < 5,
        canSellNonFiscal: daysOverdue < 10,
        isBlocked: daysOverdue >= 10,
        isAFIPBlocked: daysOverdue >= 5,
        blockReason: daysOverdue >= 10
            ? `Suscripción vencida hace ${daysOverdue} días. Todas las ventas están bloqueadas.`
            : daysOverdue >= 5
                ? `Suscripción vencida hace ${daysOverdue} días. Facturación AFIP bloqueada.`
                : null
    };
};

export default useSubscriptionRestrictions;
